"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var antd_1 = require("antd");
var icons_1 = require("@ant-design/icons");
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
var context_1 = require("../../context");
var types_1 = require("../../types");
var StyledSelect = (0, styled_components_1.default)(antd_1.Select)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  min-width: 150px;\n"], ["\n  min-width: 150px;\n"])));
var Container = (0, styled_components_1.default)(antd_1.Input.Group)(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  margin-right: 8px;\n"], ["\n  margin-right: 8px;\n"])));
var Sort = function () {
    var _a, _b, _c;
    var ctx = (0, context_1.useTableContext)();
    var sortBy = function (key) {
        var _a, _b;
        var order = types_1.ORDERING.DESC;
        if (((_b = (_a = ctx.multipleSort) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.order) === types_1.ORDERING.DESC) {
            order = types_1.ORDERING.ASC;
        }
        ctx.setMultipleSort && ctx.setMultipleSort([{ key: key, order: order }]);
        ctx.onMultipleSort && ctx.onMultipleSort([{ key: key, order: order }]);
    };
    var sort = (_a = ctx.multipleSort) === null || _a === void 0 ? void 0 : _a[0];
    return (react_1.default.createElement(Container, { compact: true, className: "sort-container" },
        react_1.default.createElement(StyledSelect, { value: sort === null || sort === void 0 ? void 0 : sort.key, onChange: function (value) {
                ctx.setMultipleSort && ctx.setMultipleSort([{ key: value }]);
            } }, (_c = (_b = ctx.columnsObject) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.filter(function (c) { return c.isSortable; }).map(function (column, i) {
            return (react_1.default.createElement(antd_1.Select.Option, { value: column.key, key: column.key + i }, column.title));
        })),
        react_1.default.createElement(antd_1.Button, { onClick: function () {
                sortBy((sort === null || sort === void 0 ? void 0 : sort.key) || "");
            }, type: "default", size: "middle", ghost: true }, (sort === null || sort === void 0 ? void 0 : sort.order) === types_1.ORDERING.DESC ? react_1.default.createElement(icons_1.SortAscendingOutlined, null) : react_1.default.createElement(icons_1.SortDescendingOutlined, null))));
};
exports.default = Sort;
var templateObject_1, templateObject_2;
//# sourceMappingURL=sort.js.map